module.exports = __webpack_public_path__ + "img/index_top.d6c7fcd5.png";